import { render } from "./adding.vue?vue&type=template&id=fb0d770c"
import script from "./adding.vue?vue&type=script&lang=js"
export * from "./adding.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./adding.vue?vue&type=style&index=0&id=fb0d770c&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__